<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>

<script lang="ts">
import type { PropType } from 'vue';
import { useHead } from '@unhead/vue';
import { groupBy, mapValues } from 'lodash-es';
import type { HeadTag } from './HeadTags.types';

/**
 * This component is mainly available for builder.io usages.
 * If you want to add tags to the head of the page, rely on the unhead package directly!
 */
export default {
    name: 'HeadTags',
    props: {
        /** definition of tags */
        tags: {
            type: Array as PropType<HeadTag[]>,
            required: true,
        },
    },
    setup(props) {
        const tagGroups = groupBy(props.tags, 'type');
        const head = mapValues(tagGroups, (tags) =>
            tags.map((tag) => {
                // map attributes array to object values
                const attrs = Object.fromEntries(
                    tag.attributes?.map(
                        (attr) =>
                            [
                                attr.name,
                                // certain attributes are just booleans without a value, so we mark them as true
                                attr.value ?? true,
                            ] as [string, string | boolean],
                    ) ?? [],
                );
                if (tag.content) {
                    attrs.innerHTML = tag.content;
                }
                return attrs;
            }),
        );
        useHead(head);
    },
};
</script>
